import { addApolloState, initializeApollo } from 'lib/clients/apolloClient';
import { GLOBAL } from 'queries';

const HowItWorks = () => {
  return <div>HowItWorks</div>;
};

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await Promise.all([
    apolloClient.query({
      query: GLOBAL,
    }),
  ]);

  return addApolloState(apolloClient, {
    props: {},
    revalidate: 60 * 5,
  });
}

export default HowItWorks;
